import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import { type FC } from "react";

export const CursorLogo: FC<PropsWithClassName> = ({ className }) => {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.5 6.66971V13.3303C17.5 13.8722 17.2077 14.372 16.7354 14.6377L10.7354 18.0127C10.2788 18.2695 9.72125 18.2695 9.26463 18.0127L3.26461 14.6377C2.79229 14.372 2.5 13.8722 2.5 13.3303V6.66971C2.5 6.1278 2.79229 5.62802 3.26461 5.36235L9.26463 1.98733C9.72125 1.73048 10.2788 1.73048 10.7354 1.98734L16.7354 5.36235C17.2077 5.62802 17.5 6.1278 17.5 6.66971Z"
                fill="#F6F6F6"
                stroke="#191A1A"
            />
            <path
                d="M9.95555 17.1111L16.1333 13.5556L9.95555 10L3.77777 13.5556L9.95555 17.1111Z"
                fill="url(#paint0_linear_93_1230)"
            />
            <path d="M16.1333 13.5556V6.44444L9.95557 2.88889V10L16.1333 13.5556Z" fill="url(#paint1_linear_93_1230)" />
            <path d="M9.95555 2.88889L3.77777 6.44444V13.5556L9.95555 10V2.88889Z" fill="url(#paint2_linear_93_1230)" />
            <path d="M16.1333 6.44446L9.95557 17.1111V10L16.1333 6.44446Z" fill="#555555" />
            <path d="M16.1333 6.44446L9.95555 10L3.77777 6.44446H16.1333Z" fill="black" />
            <defs>
                <linearGradient
                    id="paint0_linear_93_1230"
                    x1="9.95555"
                    y1="10"
                    x2="9.95555"
                    y2="17.1111"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.16" stopOpacity="0.39" />
                    <stop offset="0.658" stopOpacity="0.8" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_93_1230"
                    x1="16.1333"
                    y1="6.46637"
                    x2="9.95557"
                    y2="10.0889"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.182" stopOpacity="0.31" />
                    <stop offset="0.715" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_93_1230"
                    x1="9.95555"
                    y1="2.88889"
                    x2="3.77777"
                    y2="13.5556"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopOpacity="0.6" />
                    <stop offset="0.667" stopOpacity="0.22" />
                </linearGradient>
            </defs>
        </svg>
    );
};
